/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetObjectiveQueryResponse, GetObjectivePathParams, GetObjective400, GetObjective401, GetObjective403, GetObjective404, GetObjective409, GetObjective500 } from "../../types/planningTasksController/GetObjective.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getObjective } from "../../client/planningTasksController/getObjective.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getObjectiveQueryKey = (organizationId: GetObjectivePathParams["organizationId"] | undefined, objectiveId: GetObjectivePathParams["objectiveId"] | undefined) => [{ url: '/api/organizations/:organizationId/objectives/:objectiveId', params: {organizationId:organizationId,objectiveId:objectiveId} }] as const

export type GetObjectiveQueryKey = ReturnType<typeof getObjectiveQueryKey>

export function getObjectiveQueryOptions(organizationId: GetObjectivePathParams["organizationId"] | undefined, objectiveId: GetObjectivePathParams["objectiveId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getObjectiveQueryKey(organizationId, objectiveId)
        return queryOptions<GetObjectiveQueryResponse, ResponseErrorConfig<GetObjective400 | GetObjective401 | GetObjective403 | GetObjective404 | GetObjective409 | GetObjective500>, GetObjectiveQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && objectiveId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getObjective(organizationId!, objectiveId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get objective by ID
 * {@link /api/organizations/:organizationId/objectives/:objectiveId}
 */
export function useGetObjective<TData = GetObjectiveQueryResponse, TQueryData = GetObjectiveQueryResponse, TQueryKey extends QueryKey = GetObjectiveQueryKey>(organizationId: GetObjectivePathParams["organizationId"] | undefined, objectiveId: GetObjectivePathParams["objectiveId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetObjectiveQueryResponse, ResponseErrorConfig<GetObjective400 | GetObjective401 | GetObjective403 | GetObjective404 | GetObjective409 | GetObjective500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getObjectiveQueryKey(organizationId, objectiveId)
         

         const query = useQuery({
          ...getObjectiveQueryOptions(organizationId, objectiveId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetObjective400 | GetObjective401 | GetObjective403 | GetObjective404 | GetObjective409 | GetObjective500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}